import Animation from './animation'
import * as decorations from '../decorations'

/*
 * This animation is used when we have a no-breakdown style chart (ie. calculated
 * breakdown) and one of the series is moved into a stacked column
 */
class NoBreakdownSerieAddStack extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = false
    this.ripple = false
  }

  match (serie) {
    if (!this.chart.previous) {
      return false // not an update
    }

    if (!(this.chart.previous.layout.breakdown.calculated && this.chart.layout.breakdown.calculated)) {
      // Not to/from a no-breakdown chart
      return false
    }

    if (this.exitingSeries.size() > 0) {
      return false
    }

    if (!serie.stackBy) {
      return false // not stacked
    }

    let r0 = this.chart.previous.layout.breakdown.range
      , r1 = this.chart.layout.breakdown.range

    return r1.length !== r0.length
  }

  animate (serie, entering, selection, merged, exiting) {
    this.chart.yTransition.duration(this.timing.duration) // Sync the y-axis w/ the left-most transition
                          .delay(this.timing.duration) // Don't move the y-axis until we start vertical movements

    if (entering.size() && exiting.size()) {
      this._insertZeroHeight(entering, serie)

      // This new node is actually starting at the exiting node's location
      // The parent animation thinks it's a new node bc of the way the data
      // is bound w/ the rangeid. Since this is a no-breakdown chart, the rangeids are mocked and messy
      entering.html(exiting.selection().html())

      let exitingRect = exiting.selection().select('rect')
      // force all borders on the new object
      entering.selectAll('.border').data(['left', 'right', 'top', 'bottom'])
      entering.call(decorations.position, this.strokeWidth, {
        x: +exitingRect.attr('x'),
        width: +exitingRect.attr('width'),
        y: +exitingRect.attr('y'),
        height: +exitingRect.attr('height')
      }, labelsConfig)
      // Remove the old node now that the new node has been positioned at its location
      exiting.selection().remove()
    }

    merged.duration(this.timing.duration)
          .tween('decorations', this.tweeners.decorations) // TODO See above. In the old code, I had to break this out and only update non-entering points?
          .tween('vertical', this.tweeners.vertical)
          .transition()
          .tween('decorations', this.tweeners.decorations) // TODO See above. In the old code, I had to break this out and only update non-entering points?
          .tween('horizontal', this.tweeners.horizontal)

  }

}

export default NoBreakdownSerieAddStack
